module.exports = __webpack_public_path__ + "img/admin-avatar.c8a44153.png";